import React, { useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, MenuItem, Select, type SelectChangeEvent, Stack } from "@mui/material";

import { useNewsFeed } from "../context/NewsFeedContext";

const filterSelectSx = (active: boolean) =>
  ({
    height: 26,
    bgcolor: "#fff",
    borderRadius: "32px",
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "16px",
    color: active ? "#26a6ae" : "#071F35",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: active ? "#26a6ae" : "#92A7BC"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: active ? "#26a6ae" : "#92A7BC"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: active ? "#26a6ae" : "#92A7BC"
    },
    "& .MuiSelect-select": {
      py: "4px",
      pl: "8px",
      pr: "26px !important",
      minHeight: "16px",
      lineHeight: "16px",
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    "& .MuiSelect-icon": {
      fontSize: 16,
      color: "#071F35",
      right: 8
    }
  }) as const;

const filterMenuItemSx = {
  fontSize: 12,
  fontWeight: 400,
  lineHeight: "16px",
  color: "#071F35",
  py: "4px",
  minHeight: 0,
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
} as const;

export const NewsFeedFilters: React.FC = () => {
  const {
    feedConfig: {
      topics: { user: userTopics, system: systemTopics },
      sources: { user: userSources, system: systemSources }
    },
    // dealsCoverage,
    filters,
    setFilters,
    resetFilters
  } = useNewsFeed();

  // const filterDeals = useMemo(() => dealsCoverage.filter((deal) => deal.tracked), [dealsCoverage]);

  const availableTopics = useMemo(() => {
    if (userTopics.length) {
      return userTopics;
    }
    return systemTopics;
  }, [userTopics, systemTopics]);

  const availableSources = useMemo(() => {
    if (userSources.length) {
      return userSources;
    }
    return systemSources;
  }, [userSources, systemSources]);

  const hasFilters = Object.values(filters).some(Boolean);

  return (
    <Stack direction="row" alignItems="center" gap="7px">
      {/* <Select
        displayEmpty
        value={filters.type}
        onChange={(e: SelectChangeEvent<string>) => setFilters((filters) => ({ ...filters, type: e.target.value }))}
        renderValue={(value) => (value === "deal" ? "Deal news" : value === "topic" ? "Topic news" : "All types")}
        sx={{ ...filterSelectSx(Boolean(filters.type)), minWidth: 108 }}
      >
        <MenuItem value="" sx={filterMenuItemSx}>
          All types
        </MenuItem>
        <MenuItem value="deal" sx={filterMenuItemSx}>
          Deal news
        </MenuItem>
        <MenuItem value="topic" sx={filterMenuItemSx}>
          Topic news
        </MenuItem>
      </Select> */}
      <Select
        displayEmpty
        value={filters.topic}
        onChange={(e: SelectChangeEvent<string>) => setFilters((filters) => ({ ...filters, topic: e.target.value }))}
        renderValue={(value) => (value ? value : "All topics")}
        sx={{ ...filterSelectSx(Boolean(filters.topic)), width: "150px !important" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 400, width: "150px !important" } } }}
      >
        <MenuItem value="" sx={filterMenuItemSx}>
          All topics
        </MenuItem>
        {availableTopics.map((t) => (
          <MenuItem key={t.id} value={String(t.title)} sx={filterMenuItemSx}>
            {t.title}
          </MenuItem>
        ))}
      </Select>
      <Select
        displayEmpty
        value={filters.source}
        onChange={(e: SelectChangeEvent<string>) => setFilters((filters) => ({ ...filters, source: e.target.value }))}
        renderValue={(value) => (value ? value : "All sources")}
        sx={{ ...filterSelectSx(Boolean(filters.source)), width: "150px !important" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 400, width: "150px !important" } } }}
      >
        <MenuItem value="" sx={filterMenuItemSx}>
          All sources
        </MenuItem>
        {availableSources.map((s) => (
          <MenuItem key={s.source_url} value={String(s.name)} sx={filterMenuItemSx}>
            {s.name}
          </MenuItem>
        ))}
      </Select>
      {/* <Select
        displayEmpty
        value={filters.deal}
        onChange={(e: SelectChangeEvent<string>) => setFilters((filters) => ({ ...filters, deal: e.target.value }))}
        renderValue={(value) => value || "All deals"}
        sx={{ ...filterSelectSx(Boolean(filters.deal)), minWidth: 160 }}
      >
        <MenuItem value="" sx={filterMenuItemSx}>
          All deals
        </MenuItem>
        {filterDeals.map((deal) => (
          <MenuItem key={deal.id} value={deal.title} sx={filterMenuItemSx}>
            {deal.title}
          </MenuItem>
        ))}
      </Select> */}
      <Button
        disabled={!hasFilters}
        onClick={resetFilters}
        variant="text"
        size="sm"
        startIcon={<CloseIcon sx={{ width: "16px", height: "16px" }} />}
        sx={{
          color: "#5d7782",
          "&:hover": {
            color: "#26a6ae"
          }
        }}
      >
        Clear
      </Button>
    </Stack>
  );
};
